var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.uri !== null)?_c('q-img',{class:_vm.nftClass,staticStyle:{"max-width":"300px","height":"300px"},attrs:{"src":_vm.uri,"fit":"scaled-down","spinner-color":"white"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }